module.exports = __webpack_public_path__ + "static/media/thirdCircleLineMK2.9ee1cdfa.svg";